<template>
  <BaseButton primary @click="handleView"> View </BaseButton>
</template>

<script>
export default {
  props: {
    approvalRequest: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleView() {
      //
    },
  },
};
</script>
